export const SNACKBAR_HIDE = 'SNACKBAR_HIDE';
export const INFO_MESSAGE_SHOW = 'INFO_MESSAGE_SHOW';
